export default __webpack_public_path__ + "static/media/blue-standing-raccoon.6b630fc4.jpg";